/* © 2016 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 2016
 * For information or permission request, email info@aetonixsystems.com
 */

import par from "par";

import defineUI from "../shared/define";
import render from "./render.jsx";
import PersonStore from "../stores/person_store";
import UserStore from "../stores/user_active_store";
import UserUrgencyStore from "../stores/user_urgency_store";
import UserUrgencyPreferenceStore from "../stores/user_urgency_preference_store";
import StaffStore from "../stores/staff_store";
import LocalizationStore from "../stores/localization_store";
import CurrentPersonInfoStore from "../stores/current_person_info_store";
import CareplanNotificationStore from "../stores/careplan_notice_store";
import ConnectionStore from "../stores/connection_store";
import makeStoreFactory from "../shared/stores";

const makeStores = makeStoreFactory({
	people: PersonStore,
	currentPerson: CurrentPersonInfoStore,
	localization: LocalizationStore,
	users: UserStore,
	urgency: UserUrgencyStore,
	urgencyPreferences: UserUrgencyPreferenceStore,
	staff: StaffStore,
	careplanChangeList: CareplanNotificationStore,
	connection: ConnectionStore
});

function make_ui(api, events, config, userMetrics) {
	var storeStore = makeStores(api, events, config);

	window.stores = storeStore.store;

	userMetrics.trackEvent("page view", {
		"page": "user-urgency",
		"category": "user",
		"permission level": "staff",
	});

	return defineUI({
		getInitialState: getInitialState,
		componentDidMount: listen_for_changes,
		render: render,
		componentWillUnmount: removeListeners
	});

	function removeListeners() {
		events.off();
	}

	function listen_for_changes() {
		storeStore.listen(par(handle_change, this));
	}

	function handle_change(component, stores) {
		component.setState({
			people: stores.people,
			currentPerson: stores.currentPerson,
			localization: stores.localization,
			urgency: stores.urgency,
			urgencyPreferences: stores.urgencyPreferences,
			users: stores.users.all(),
			staff: stores.staff.all(),
			careplanChangeList: stores.careplanChangeList,
			connection: stores.connection
		});
	}

	function getInitialState() {
		return {
			people: storeStore.stores.people,
			currentPerson: storeStore.stores.currentPerson,
			localization: storeStore.stores.localization,
			urgency: storeStore.stores.urgency,
			urgencyPreferences: storeStore.stores.urgencyPreferences,
			viewing: null,
			toRemove: null,
			searching: false,
			users: [],
			staff: [],
			addContact: addContact,
			removeContact: removeContact,
			setOrdered: setOrdered,
			search: doSearch,
			selectedIndex: 0,
			loadMore: par(loadMore, storeStore.stores.users),
			searchExist: par(searchExist, storeStore.stores.users),
			careplanChangeList: storeStore.stores.careplanChangeList,
			connection: storeStore.stores.connection,
			userMetrics: userMetrics,
		};
	}

	function loadMore(user){
		return user.more();
	}

	function searchExist(users, event){
    event.persist();
    var query = event.target.value;
		return users.search(query);
	}

	function doSearch(query) {
		return api.people.search(query);
	}

	function addContact(user, who) {
		userMetrics.trackEvent("user-urgency: add urgency contact", {
			patient: who,
			"urgency contact": user
		});
		return api.org.urgency.addStaff(user, who);
	}

	function removeContact(user, who) {
		return api.org.urgency.remove(user, who);
	}

	function setOrdered(user, ordered) {
		return api.org.urgency.preferences.update(user, {
			ordered: ordered
		});
	}

}

export default make_ui;
